module.exports = __webpack_public_path__ + "static/media/PreviewWood.b11117be.jpeg";